$rise_devtools_selector $mol_view
	auto /
		<= mousemove_listener null $mol_dom_listener
		<= click_listener null $mol_dom_listener
		<= keydown_listener null $mol_dom_listener
	active? false
	rpc_port \
	document null
	done? null
	reset null
	target? null
	target_info null
	rect? null
	target_id? \
	target_name? \
	target_attrs? /
	selected? false
	sub /
		<= Overlay $rise_devtools_selector_overlay
			active <= active? false
			rect <= rect null
			target_id <= target_id \
			target_name <= target_name \
			target_attrs <= target_attrs /
			target_info <= target_info null
			selected? <=> selected? false
			rpc_port <= rpc_port \
